export const ACTION = {
    CREATE: 'create',
    IMPORT: 'import',
    RENEW: 'renew',
};

export const HELP_FEED_URL = 'https://support.fusebox.fm/article/438-find-rss-url';

export const STEPS = {
    TYPE_SELECT: 'type_select',
    CREATE_SHOW: 'create_show',
    IMPORT_SHOW: 'import_show',
    CONFIRM_IMPORT: 'confirm_import',
    PLAN_SELECT: 'plan_select',
    TRIAL: 'trial',
    CHECKOUT: 'checkout',
};

export const ACTION_STEPS = {
    [ACTION.CREATE]: [
        STEPS.TYPE_SELECT,
        STEPS.CREATE_SHOW,
        STEPS.PLAN_SELECT,
        STEPS.TRIAL,
        STEPS.CHECKOUT,
    ],
    [ACTION.IMPORT]: [
        STEPS.TYPE_SELECT,
        STEPS.IMPORT_SHOW,
        STEPS.CONFIRM_IMPORT,
        STEPS.PLAN_SELECT,
        STEPS.TRIAL,
        STEPS.CHECKOUT,
    ],
    [ACTION.RENEW]: [
        STEPS.PLAN_SELECT,
        STEPS.TRIAL,
        STEPS.CHECKOUT,
    ],
};
